import { Dataflow02 } from '@untitledui/icons'

import { useDesktopNavigation } from '@components/navbar/desktop/DesktopNavigationContext'
import useHasSystemRole from '@hooks/useHasSystemRole.ts'
import { routesFactory } from '@utils/routes.ts'

import NavItem from './NavItem'

function WorkflowsNavItem() {
  const { isActive } = useDesktopNavigation()

  const isDeveloper = useHasSystemRole('DEVELOPER')
  if (!isDeveloper) return null

  return (
    <NavItem
      to={routesFactory.workflows()}
      label="Workflows"
      isActive={isActive('workflows')}
      icon={<Dataflow02 size={20}/>}
    />
  )
}

export default WorkflowsNavItem

